import { Link } from 'react-router-dom';
import { contactInfo } from '@/mocks/brand';

const footerLinks = [
  {
    title: '产品系列',
    links: [
      { label: '呦呦·护肤', path: '/categories?tab=skincare' },
      { label: '呦呦·香氛', path: '/categories?tab=fragrance' },
      { label: '呦呦·茶品', path: '/categories?tab=tea' },
      { label: '呦呦·家居', path: '/categories?tab=home' },
    ],
  },
  {
    title: '了解更多',
    links: [
      { label: '品牌故事', path: '/articles/youyou-brand-story' },
      { label: '关于我们', path: '/about' },
      { label: '全部文章', path: '/articles' },
    ],
  },
  {
    title: '客户服务',
    links: [
      { label: '常见问题', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="font-heading text-2xl font-semibold tracking-wider text-background-50">
                呦呦
              </Link>
              <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-sm">
                源自《诗经》，归于自然。将千年东方美学融入现代生活，让每一天都充满呦呦之美。
              </p>
              <div className="flex items-center gap-4 mt-5">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-background-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-background-200" />
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-background-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-background-200" />
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-background-600 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-red-packet-line text-sm text-background-200" />
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 呦呦 YouYou. All rights reserved.
            </p>
            <p className="text-xs text-background-400">
              {contactInfo.address}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}